import { SET_AUTH, LOGOUT } from './types'

export const setAuth = (payload) => ({
  type: SET_AUTH,
  payload,
})

export const logout = () => ({
  type: LOGOUT,
})
